import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { ADD_CAREGIVER } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { AddCaregiverPayload, AddCaregiverResult } from '../types/addCaregiver.types';

export const addCaregiver = (builder: BuilderType) =>
  builder.mutation<AddCaregiverResult, AddCaregiverPayload>({
    query: (data) => ({
      data,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: ADD_CAREGIVER,
    }),
    transformResponse: (response: GenericApiResponse<AddCaregiverResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
